import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgValid24 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "w12gaepqqa",
			width: "114.6%",
			height: "245.8%",
			x: "-7.3%",
			y: "-72.9%",
			filterUnits: "objectBoundingBox",
			children: [
				/* @__PURE__ */ _jsx("feOffset", {
					dy: 2,
					in: "SourceAlpha",
					result: "shadowOffsetOuter1"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					in: "shadowOffsetOuter1",
					result: "shadowBlurOuter1",
					stdDeviation: 8
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "shadowBlurOuter1",
					result: "shadowMatrixOuter1",
					values: "0 0 0 0 0.239215686 0 0 0 0 0.333333333 0 0 0 0 0.403921569 0 0 0 0.1 0"
				}),
				/* @__PURE__ */ _jsxs("feMerge", { children: [/* @__PURE__ */ _jsx("feMergeNode", { in: "shadowMatrixOuter1" }), /* @__PURE__ */ _jsx("feMergeNode", { in: "SourceGraphic" })] })
			]
		}) }),
		/* @__PURE__ */ _jsx("g", {
			fill: "none",
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", {
				filter: "url(#w12gaepqqa)",
				transform: "translate(-672 -1515) translate(652 1479) translate(0 24)",
				children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
					fill: "#40C88A",
					d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2",
					transform: "translate(20 12)"
				}), /* @__PURE__ */ _jsx("path", {
					fill: "#000",
					d: "M17.8 9.6l-6 8c-.174.232-.44.377-.729.397-.023.002-.047.003-.071.003-.264 0-.519-.105-.707-.293l-4-4c-.39-.391-.39-1.024 0-1.414.391-.391 1.024-.391 1.414 0l3.185 3.184L16.2 8.4c.331-.441.958-.531 1.4-.2.442.331.532.958.2 1.4",
					transform: "translate(20 12)"
				})] })
			}) }) })
		})
	]
});
const ForwardRef = forwardRef(SvgValid24);
export default ForwardRef;
